<div class="container term-screen">

  <div class="term-content">

    <header class="page-head">

      @if(solicitacaoAndamento && exibirModal === false) {
      <div class="page-head__row">

        <h1 class="page-title">
          Perfil de Investidor
        </h1>

        <button class="btn btn-white page-head__link" (click)="viewForm()">
          Ver questionário preenchido

          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true">
            <path
              d="M10.666 2.66663H11.9993C12.353 2.66663 12.6921 2.8071 12.9422 3.05715C13.1922 3.3072 13.3327 3.64634 13.3327 3.99996V13.3333C13.3327 13.6869 13.1922 14.0261 12.9422 14.2761C12.6921 14.5262 12.353 14.6666 11.9993 14.6666H3.99935C3.64573 14.6666 3.30659 14.5262 3.05654 14.2761C2.80649 14.0261 2.66602 13.6869 2.66602 13.3333V3.99996C2.66602 3.64634 2.80649 3.3072 3.05654 3.05715C3.30659 2.8071 3.64573 2.66663 3.99935 2.66663H5.33268"
              stroke="#3C2E88" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path
              d="M10.0007 1.33337H6.00065C5.63246 1.33337 5.33398 1.63185 5.33398 2.00004V3.33337C5.33398 3.70156 5.63246 4.00004 6.00065 4.00004H10.0007C10.3688 4.00004 10.6673 3.70156 10.6673 3.33337V2.00004C10.6673 1.63185 10.3688 1.33337 10.0007 1.33337Z"
              stroke="#3C2E88" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>

        </button>
      </div>

      <p class="page-protocol">
        Protocolo
        <span class="page-protocol__value">{{ perfilParticipante?.numProtocoloSolicitacao }}</span>
      </p>
      }
      @else {
      <h1 class="page-title">
        Resumo
      </h1>
      }

    </header>

    <div class="summary-section">

      <div class="summary-cards">

        <app-summary-card
          label="Perfil anterior:"
          [value]="perfilParticipante?.perfilAtual">
        </app-summary-card>

        @if(solicitacaoAndamento && exibirModal === false) {
          <app-summary-card
            label="Perfil atual:"
            [value]="perfilParticipante?.perfilSelecionado">
          </app-summary-card>
        } @else {
          <app-summary-card
            label="Perfil selecionado:"
            [value]="nomePerfilSelecionado">
          </app-summary-card>
        }
        @if(campanha?.dtIniVigPartic){
          <app-summary-card
            label="Válido a partir de:"
            [value]="campanha?.dtIniVigPartic | date:'dd/MM/yyyy'">
          </app-summary-card>
        }
      </div>

    </div>

    <!-- =====================================================================
         Documento e assinatura formam um único objeto: barra de controles no
         topo, o papel sobre a superfície recuada, e a linha de assinatura na
         base. Assim não há dúvida sobre qual documento está sendo aceito.
         ===================================================================== -->
    <section class="term-doc" [class.term-doc--signed]="solicitacaoAndamento && exibirModal === false">

      <div class="term-doc__heading">
        @if(solicitacaoAndamento && exibirModal === false){

        <p class="term-doc__status">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
            aria-hidden="true">
            <path
              d="M22 11.0801V12.0001C21.9988 14.1565 21.3005 16.2548 20.0093 17.9819C18.7182 19.7091 16.9033 20.9726 14.8354 21.584C12.7674 22.1954 10.5573 22.122 8.53447 21.3747C6.51168 20.6274 4.78465 19.2462 3.61096 17.4372C2.43727 15.6281 1.87979 13.4882 2.02168 11.3364C2.16356 9.18467 2.99721 7.13643 4.39828 5.49718C5.79935 3.85793 7.69279 2.71549 9.79619 2.24025C11.8996 1.76502 14.1003 1.98245 16.07 2.86011"
              stroke="#1B894A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M22 4L12 14.01L9 11.01" stroke="#1B894A" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>

          <span class="term-doc__status-text">
            <strong class="term-doc__status-title">Termo assinado</strong>
            <span class="term-doc__status-when">
              em {{ perfilParticipante?.dataConfirmacaoTermo | date:'dd/MM/yyyy' }}
              às {{ perfilParticipante?.dataConfirmacaoTermo | date:'HH:mm' }}
            </span>
          </span>
        </p>

        } @else {
        <h2 class="term-doc__title">
          Revise e assine o termo de adesão
        </h2>
        }
      </div>

      <div class="term-doc__shell">

        <div class="term-doc__bar">
          <p class="term-doc__name">Termo de adesão</p>

          <!-- Dois grupos separados por espaço (não por um traço decorativo):
               ajustar a visualização à esquerda, agir sobre o documento à
               direita. -->
          <div class="term-doc__tools">

            <div class="term-doc__tool-group">
              <button class="term-doc__tool" type="button" (click)="zoomOut()" [disabled]="pdfZoom <= 0.5"
                title="Diminuir zoom" aria-label="Diminuir zoom">
                <img src="assets/images/icons/fi_zoom-out.svg" alt="" />
              </button>
              <button class="term-doc__tool" type="button" (click)="zoomIn()" [disabled]="pdfZoom >= 3"
                title="Aumentar zoom" aria-label="Aumentar zoom">
                <img src="assets/images/icons/fi_zoom-in.svg" alt="" />
              </button>
            </div>

            <div class="term-doc__tool-group">
              <button class="term-doc__tool" type="button" (click)="downloadTerm()" [disabled]="!pdfSrc"
                title="Baixar o termo em PDF" aria-label="Baixar o termo em PDF">
                <img src="assets/images/icons/fi_download.svg" alt="" />
              </button>
              <button class="term-doc__tool" type="button" (click)="toggleFullscreen()"
                [title]="isFullscreen ? 'Fechar tela cheia' : 'Tela cheia'"
                [attr.aria-label]="isFullscreen ? 'Fechar tela cheia' : 'Abrir em tela cheia'">
                <img src="assets/images/icons/fi_maximize-2.svg" alt="" />
              </button>
            </div>
          </div>
        </div>

        <div class="term-doc__stage" [class.fullscreen]="isFullscreen">

          @if(isFullscreen) {
          <button class="btn btn-outline-primary term-doc__close" type="button" (click)="toggleFullscreen()">
            Fechar <img src="assets/images/icons/la_times.svg" alt="" />
          </button>
          }

          @if(pdfSrc){

          <!-- data-iframe-ignore: o pdf.js posiciona cada página em absolute dentro do
               seu próprio container com scroll. O iframe-resizer observa elementos
               posicionados e usa os que transbordam para medir a página, então as
               páginas do PDF fora da área visível faziam o app reportar uma altura
               enorme ao iframe pai. Este atributo exclui a subárvore da medição. -->
          <pdf-viewer
            data-iframe-ignore
            [src]="pdfSrc"
            [render-text]="true"
            [original-size]="false"
            [show-all]="true"
            [autoresize]="true"
            [zoom-scale]="'page-width'"
            [zoom]="pdfZoom"
            class="term-doc__page">
          </pdf-viewer>
          }
        </div>

        @if(solicitacaoAndamento && exibirModal === false) {
        <p class="term-doc__note">
          Termo assinado. Baixe uma via em PDF pelo ícone de download acima.
        </p>
        }
        @else {
        <div class="term-doc__sign">

          <app-checkbox class="alert-checkbox" [(checked)]="agreeTerm" label="Li e estou de acordo">
          </app-checkbox>

          <div class="button-content">
            <button class="btn btn-outline-primary" type="button" (click)="goBack()">Voltar</button>
            <button class="btn btn-primary" type="button" [disabled]="!agreeTerm || isSigning"
              (click)="confirm()">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true">
                <g clip-path="url(#clip0_256_516)">
                  <path
                    d="M14.6663 7.38674V8.00007C14.6655 9.43769 14.2 10.8365 13.3392 11.988C12.4785 13.1394 11.2685 13.9817 9.88991 14.3893C8.51129 14.797 7.03785 14.748 5.68932 14.2498C4.3408 13.7516 3.18944 12.8308 2.40698 11.6248C1.62452 10.4188 1.25287 8.99212 1.34746 7.55762C1.44205 6.12312 1.99781 4.75762 2.93186 3.66479C3.86591 2.57195 5.1282 1.81033 6.53047 1.4935C7.93274 1.17668 9.39985 1.32163 10.713 1.90674"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M14.6667 2.66675L8 9.34008L6 7.34008" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round" />
                </g>
                <defs>
                  <clipPath id="clip0_256_516">
                    <rect width="16" height="16" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              Assinar termo
            </button>
          </div>
        </div>
        }

      </div>
    </section>

    @if(solicitacaoAndamento && exibirModal === false) {
    <div class="signed-actions">
      <button class="btn btn-secondary" type="button" (click)="openModalCancel()">
        Refazer perfil de investidor
      </button>
    </div>
    }

  </div>

  <app-modal [visible]="exibirModal" [maxWidth]="'512px'">

    <div class="modal-content-custom">

      <img src="assets/images/icons/Check.svg" alt="" class="modal-icon mb-32" />

      <h2 class="modal-message">
        Perfil atualizado com sucesso
      </h2>
      <p>
        Seu novo perfil passa a valer a partir de {{ campanha?.dtIniVigPartic | date:'dd/MM/yyyy' }}
      </p>

      <div class="button-content justify-content-center d-flex">
        <button class="btn btn-outline-primary" (click)="inicio()">Inicio</button>
        <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="viewTerm()">
          Ver detalhes
        </button>
      </div>

    </div>

  </app-modal>

  <app-modal [visible]="modalCancelamento" [maxWidth]="'630px'">

    <div class="modal-content-custom">

      <svg class="mb-24" width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true">
        <path
          d="M48.9368 11.1994L53.1265 15.3891C55.402 17.6646 55.4021 21.3665 53.1268 23.6418L23.7239 53.0447C21.4485 55.32 17.7467 55.3199 15.4712 53.0445L11.2815 48.8547C9.006 46.5792 9.0059 42.8774 11.2812 40.6021L40.6841 11.1992C42.9595 8.92383 46.6613 8.92393 48.9368 11.1994ZM17.765 50.7506C18.7775 51.7631 20.4228 51.7632 21.4352 50.7508L50.8381 21.3479C51.8505 20.3354 51.8505 18.6902 50.838 17.6777L46.6483 13.4879C45.6358 12.4754 43.9905 12.4754 42.9781 13.4878L13.5725 42.8934C12.5601 43.9058 12.5602 45.5511 13.5727 46.5636L17.7624 50.7533L17.765 50.7506Z"
          fill="#E33E5A" />
        <path
          d="M23.3979 11.1992L52.8008 40.6021C55.0761 42.8774 55.076 46.5792 52.7979 48.8574L48.6108 53.0445C46.3353 55.3199 42.6335 55.32 40.3582 53.0447L10.9553 23.6418C8.67993 21.3665 8.68003 17.6646 10.9555 15.3891L15.1452 11.1994C17.4207 8.92393 21.1226 8.92383 23.3979 11.1992ZM42.6495 50.7534C43.6619 51.7658 45.3072 51.7658 46.3197 50.7533L50.5094 46.5636C51.5219 45.5511 51.5219 43.9058 50.5095 42.8934L21.1066 13.4905C20.0942 12.478 18.4489 12.4781 17.4364 13.4906L13.2467 17.6803C12.2342 18.6928 12.2341 20.3381 13.2466 21.3505L42.6495 50.7534Z"
          fill="#3C2E88" />
        <path
          d="M28.2759 25.9008C28.9082 26.533 28.9075 27.5613 28.2742 28.1945L13.8704 42.5983C13.2372 43.2316 12.2089 43.2324 11.5766 42.6001C10.9443 41.9678 10.9451 40.9395 11.5784 40.3063L25.9821 25.9025C26.6154 25.2692 27.6436 25.2685 28.2759 25.9008Z"
          fill="#E33E5A" />
        <path
          d="M48.9039 25.5733C49.5362 26.2056 49.5355 27.2338 48.9024 27.8669L37.7725 38.9967C37.1394 39.6299 36.1113 39.6306 35.479 38.9983C34.8467 38.366 34.8474 37.3378 35.4805 36.7047L46.6103 25.5748C47.2435 24.9417 48.2716 24.941 48.9039 25.5733Z"
          fill="#E33E5A" />
      </svg>


      <div class="modal-cancel">
        <p class="modal-message">
          Você já finalizou a atualização do seu perfil
        </p>
        <span>
          Tem certeza que deseja solicitar um novo perfil de investidor?
        </span>
      </div>

      <div class="button-content justify-content-center d-flex">
        <button class="btn btn-outline-primary" (click)="closeModalCancel()">Não, voltar</button>
        <button class="btn btn-secondary d-flex justify-content-center" type="button" (click)="confirmCancel()">
          Sim, quero refazer meu perfil
        </button>
      </div>


    </div>

  </app-modal>

</div>
